import { Modal, Spinner, Form } from "react-bootstrap";
import { useContext, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import { RootContext } from "../../context/RootContext";
import UplifeButton from "../UplifeButton";

interface ChangePasswordModalProps {
  showPasswordDialog: boolean;
  setShowPasswordDialog: (value: boolean) => void;
}

const ChangePasswordModal = ({ showPasswordDialog, setShowPasswordDialog }: ChangePasswordModalProps) => {
  const rootCtx = useContext(RootContext);
  const showError = rootCtx?.showError ?? (() => {});
  const authCtx = useContext(AuthContext);
  const changePassword = authCtx?.changePassword ?? (async () => {});
  const [new1Password, setNew1Password] = useState("");
  const [new2Password, setNew2Password] = useState("");
  const [working, setWorking] = useState(false);

  async function handleClosePasswordDialog(confirm: boolean) {
    if (!confirm) return setShowPasswordDialog(false);
    setWorking(true);

    try {
      await changePassword(new1Password);
      setShowPasswordDialog(false);
      setNew1Password("");
      setNew2Password("");
    } catch (error: any) {
      showError(error);
    } finally {
      setWorking(false);
    }
  }

  return (
    <Modal
      show={showPasswordDialog}
      centered
      onHide={() => handleClosePasswordDialog(false)}
    >
      <Modal.Header closeButton style={{ border: "none" }}>
        <Modal.Title>Change password</Modal.Title>
      </Modal.Header>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          if (
            !working &&
            new1Password.length > 0 &&
            new2Password.length > 0 &&
            new1Password === new2Password
          ) {
            handleClosePasswordDialog(true);
          }
        }}
      >
        <Modal.Body>
          <Form.Group className="mb-3" controlId="ControlInput2">
            <Form.Label className="cursor-pointer">New password</Form.Label>
            <Form.Control
              type="password"
              placeholder="new password"
              value={new1Password}
              onChange={(e) => setNew1Password(e.target.value)}
              className="cursor-pointer"
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="ControlInput3">
            <Form.Label className="cursor-pointer">
              Retype new password
            </Form.Label>
            <Form.Control
              type="password"
              placeholder="retype new password"
              value={new2Password}
              onChange={(e) => setNew2Password(e.target.value)}
              className="cursor-pointer"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer style={{ border: "none" }}>
          <UplifeButton
            type="button"
            variant="link"
            onClick={() => handleClosePasswordDialog(false)}
            disabled={working}
          >
            Cancel
          </UplifeButton>
          <UplifeButton
            type="button"
            onClick={() => handleClosePasswordDialog(true)}
            disabled={
              new1Password.length === 0 ||
              new2Password.length === 0 ||
              new1Password !== new2Password
            }
          >
            {working ? <Spinner size="sm" /> : "Change"}
          </UplifeButton>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default ChangePasswordModal;
